import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Login from "./Components/Admin/Login/Login";

import Dashboard from "./Components/Admin/DashBoard/DashBoard";
import Sidebar from "./Components/Admin/Sidebar/Sidebar";
import Header from "./Components/Admin/Header/Header";

// Masters

import Country from "./Components/Admin/Masters/Country/Tables";
import State from "./Components/Admin/Masters/State/Tables";
import City from "./Components/Admin/Masters/City/Tables";

import Pincode from "./Components/Admin/Masters/Pincode/Tables";
import App_setup from "./Components/Admin/Masters/App_setup/Tables";
import UserFeedback from "./Components/Admin/Masters/RiderpartenetLang/Tables";
import GoodsType from "./Components/Admin/Masters/GoodsType/Table";
import VehicleCategory from "./Components/Admin/Masters/VehicleCatrgory/Table";
import VehicleBody from "./Components/Admin/Masters/VehicleBody/Table";
import VehicleFare from "./Components/Admin/Masters/VehicleFare/Table";
import Vehicle from "./Components/Admin/Masters/VehicleType/Table";
import BookingCancelReasons from "./Components/Admin/Masters/BookingCancelReasons/Table";
import SaveAs from "./Components/Admin/Masters/SaveAs/Table";
import CustomerAccountRelatedSupport from "./Components/Admin/Masters/CustomerAccountRelatedSupport/Table";
import CustomerFareRelatedSupport from "./Components/Admin/Masters/CustomerFareRelatedSupport/Table";
import CustomerWalletRelatedSupport from "./Components/Admin/Masters/CustomerWalletRelatedSupport/Table";
import TrainingVideo from "./Components/Admin/Masters/TrainingVideo/Table";

// Masters End

// Privacy Policy Starts
import PrivacyPolicy from "./Components/Admin/Masters/PrivacyPolicy/Table";
import TermsAndCondition from "./Components/Admin/Masters/TermsAndCondition/Table";

import DriverPrivacyPolicy from "./Components/Admin/Masters/DriverPrivacyPolicy/Table";
import DriverTermsAndCondition from "./Components/Admin/Masters/DriverTermsAndCondition/Table";

// Privacy Policy Ends

import Admin_Earnings from "./Components/Admin/Masters/Admin_Earnings/Table";

import Riders from "./Components/Admin/Customers/Riders/Tables";
import Users from "./Components/Admin/Customers/Users/Tables";
import Rides from "./Components/Admin/Customers/Rides/Table";
import ContactUs from "./Components/Admin/Customers/ContactUs/Tables";

import User_Help_Type from "./Components/Admin/Masters/User_Help_Type/Table";

import User_Help_Sub_Type from "./Components/Admin/Masters/User_Help_Sub_Type/Table";

import UserHelp from "./Components/Admin/Masters/UserHelp/Table";

import UserAdvertisement from "./Components/Admin/Masters/UserAdvertisement/Table";

import Rider_Help_Type from "./Components/Admin/Masters/RiderHelpTypeLang/Table";

import RiderHelp from "./Components/Admin/Masters/RiderHelpLang/Table";

import RiderAdvertisement from "./Components/Admin/Masters/RiderAdvertisement/Table";
import Driver_Earnings from "./Components/Admin/Drivers/Driver_Earnings/Table";
import Driver_Velicles from "./Components/Admin/Drivers/Driver_Vehicles/Table";
import Driver_List from "./Components/Admin/Drivers/Driver_List/Table";

////////////////////Wallet//////////////////////
import WalletRequest from "./Components/Admin/WalletRequest/table";

import FundAddRequest from "./Components/Admin/FundAddRequest/table";

import WalletHistory from "./Components/Admin/WalletHistory/table";

////////////////////REview And Rating//////////////////////
import Feedback from "./Components/Admin/Masters/Feedback/Table";

const App = () => {
  const location = useLocation();
  const [headerText, setHeaderText] = useState(location.pathname);

  useEffect(() => {
    setHeaderText(location.pathname);
  });
  return (
    <div className="main d-flex">
      {headerText === "/" || headerText === "/lead-dashboard" ? (
        <></>
      ) : (
        <Sidebar />
      )}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Header" element={<Header />} />
        <Route path="/dashboard" element={<Dashboard />} />
        {/* Masters Start */}
        <Route path="/masters/app-setup" element={<App_setup />} />
        <Route path="/masters/admin-earnings" element={<Admin_Earnings />} />
        <Route path="/masters/country" element={<Country />} />
        <Route path="/masters/state" element={<State />} />
        <Route path="/masters/city" element={<City />} />
        <Route path="/masters/pincode" element={<Pincode />} />
        <Route path="/masters/rider-partner" element={<UserFeedback />} />
        <Route path="/masters/fare-vehicle" element={<VehicleFare />} />{" "}
        <Route path="/masters/category-vehicle" element={<VehicleCategory />} />
        <Route path="/masters/goods-type" element={<GoodsType />} />
        <Route path="/masters/covered" element={<VehicleBody />} />
        <Route path="/masters/vehicle" element={<Vehicle />} />{" "}
        <Route
          path="/masters/booking-cancel-reasons"
          element={<BookingCancelReasons />}
        />
        <Route path="/masters/save-as" element={<SaveAs />} />
        <Route
          path="/masters/customer-account-related-support"
          element={<CustomerAccountRelatedSupport />}
        />
        <Route
          path="/masters/customer-fare-related-support"
          element={<CustomerFareRelatedSupport />}
        />
        <Route
          path="/masters/customer-wallet-related-support"
          element={<CustomerWalletRelatedSupport />}
        />
        <Route path="/masters/training-video" element={<TrainingVideo />} />
        {/* Masters Ends */}
        {/* Customers Privacy Poliocy Starts */}
        <Route path="/masters/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/masters/terms-and-conditions"
          element={<TermsAndCondition />}
        />
        {/* Customers Privacy Poliocy Ends */}
        {/* Drivers Privacy Poliocy Starts */}
        <Route
          path="/masters/driver-privacy-policy"
          element={<DriverPrivacyPolicy />}
        />
        <Route
          path="/masters/driver-terms-and-conditions"
          element={<DriverTermsAndCondition />}
        />
        {/* Drivers Privacy Poliocy Ends */}
        <Route path="/customers/driver" element={<Riders />} />
        {/*Driver Earnings */}
        <Route path="/driver/driver-earnings" element={<Driver_Earnings />} />
        {/*Driver Earnings */}
        <Route path="/driver/driver-vehicles" element={<Driver_Velicles />} />
        {/*Driver List */}
        <Route path="/driver/driver-list" element={<Driver_List />} />
        {/*Users */}
        <Route path="/customers/users" element={<Users />} />
        <Route path="/customers/rides" element={<Rides />} />
        <Route path="/customers/contact-us" element={<ContactUs />} />
        <Route path="/masters/user-help-type" element={<User_Help_Type />} />
        <Route
          path="/masters/user-help-sub-type"
          element={<User_Help_Sub_Type />}
        />
        <Route path="/masters/user-help" element={<UserHelp />} />
        <Route
          path="/masters/user-advertisement"
          element={<UserAdvertisement />}
        />
        <Route path="/masters/rider-help-type" element={<Rider_Help_Type />} />
        <Route path="/masters/rider-help" element={<RiderHelp />} />
        <Route
          path="/masters/rider-advertisement"
          element={<RiderAdvertisement />}
        />
        {/* Wallet Request */}
        <Route path="/wallet-request" element={<WalletRequest />} />
        <Route path="/wallet-fund-add-request" element={<FundAddRequest />} />
        <Route path="/wallet-history" element={<WalletHistory />} />
        {/*Wallet Request  */}
        {/* Feedback */}
        <Route path="/rating-and-review" element={<Feedback />} />
        {/*Feedback  */}
      </Routes>
    </div>
  );
};

export default App;
